import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const SubscribePackage = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-subscribe-package`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const SubscribedPackageList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-subscribed-package-list`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const PackagesList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-job-package-list`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};
